import * as React from 'react';

type IconColors = 'light' | 'grey';
interface Props {
  color?: IconColors;
}

const colors: Record<IconColors, string> = {
  light: '#FFFFFF',
  grey: '#989898',
};

const CalendarDoneIcon: React.FC<Props> = ({ color = colors['light'] }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={21} height={20} fill="none">
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.296 6.406V16.66c0 1.104.745 1.487 1.117 1.54h14.23c.774 0 1.035-1.027 1.069-1.54V6.406m-16.416 0V5.262c-.052-.536.1-1.607 1.117-1.607h14.23c.356.014 1.069.354 1.069 1.607v1.144m-16.416 0h3.561m12.855 0h-3.538m-9.317 0V1.802m0 4.604h4.658m4.659 0h-4.659m4.659 0V1.802m-4.659 4.604V1.802m-3.63 10.311 2.352 2.612L14.62 9.27"
    />
  </svg>
);
export default React.memo(CalendarDoneIcon);
